<template>
  <div>
    <Breadcrumb :routeName="backRouteName" toName="订单详情" :goPathName="backRouteName === 'TravelMode' ? '定制游服务' : '订单管理'"></Breadcrumb>
    <a-card :bordered="false" style="margin-bottom:15px;">
      <a-row>
        <a-col :span="17">
          <detail-list :col="1" class="order-big">
            <detail-list-item term="订单编号">{{ orderDetails.travelMadeOrderNo }}</detail-list-item>
          </detail-list>
        </a-col>
        <a-col :span="7" class="btns-list">
          <a-button class="mb10" type="danger"
                    v-if="orderDetails.travelMadeOrderStatus==1 || orderDetails.travelMadeOrderStatus==4"
                    ghost
                    @click="showkInitRefundModal">主动退款
          </a-button>
          <a-button class="mb10" type="primary" @click="showRemarkModal">添加备注</a-button>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="7">
          <detail-list :col="1">
            <detail-list-item term="下单时间">{{ orderDetails.travelMadeOrderCreateTime }}</detail-list-item>
            <detail-list-item term="支付方式" v-if="orderDetails.travelMadePayTypeStr">
              {{ orderDetails.travelMadePayTypeStr }}
            </detail-list-item>
            <detail-list-item term="出游日期" v-if="orderDetails.travelMadeOrderDate">
              {{ orderDetails.travelMadeOrderDate }}
            </detail-list-item>
            <detail-list-item term="余额支付"
                              v-if="orderDetails.travelMadeOrderStatus!=0&&orderDetails.travelMadeBalanceAmt>0">
              ¥{{ orderDetails.travelMadeBalanceAmt }}
            </detail-list-item>
            <detail-list-item term="供应商">{{ orderDetails.merchantFullName }}&nbsp;&nbsp;&nbsp;<br>
              姓名：{{ orderDetails.merchantContact }}&nbsp;&nbsp;&nbsp;电话：{{ orderDetails.merchantMobile }}
            </detail-list-item>
          </detail-list>
        </a-col>
        <a-col :span="10">
          <detail-list :col="1">
            <detail-list-item style="width: 90%;" term="购买商品">{{ orderDetails.travelMadeOrderName }}
            </detail-list-item>
            <detail-list-item term="方案附件"><a :href="orderDetails.travelMadeOrderPdfUrl" target="_blank">下载</a>
            </detail-list-item>
            <detail-list-item term="内部团号" v-if="orderDetails.travelMadeOrderInternalNo">
              {{ orderDetails.travelMadeOrderInternalNo }}
            </detail-list-item>
            <detail-list-item term="数量">成人： {{ orderDetails.travelMadeOrderAdultsNum }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;儿童：
              {{ orderDetails.travelMadeOrderChildNum }}
            </detail-list-item>
          </detail-list>
        </a-col>
        <a-col :span="7">
          <a-row class="status-list">
            <a-col :xs="12" :sm="12">
              <div class="text">状态</div>
              <div class="heading">{{ orderDetails.travelMadeOrderStatusStr }}</div>
            </a-col>
            <a-col :xs="12" :sm="12">
              <div class="text">订单金额</div>
              <div class="heading">¥ {{ orderDetails.travelMadeOrderAmt }}</div>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-card>
    <a-card :bordered="false" :bodyStyle="{padding:'0px'}">
      <a-card class="install-ly" title="联系人信息" :bordered="false" :headStyle="{borderBottom:'0px'}">
        <detail-list :col="1">
          <detail-list-item term="姓名">{{ orderDetails.travelMadeOrderContact }}</detail-list-item>
          <detail-list-item term="联系电话">{{ orderDetails.travelMadeOrderMobile }}</detail-list-item>
        </detail-list>
      </a-card>
      <a-card class="install-ly" v-if="orderDetails.orderRefundTime" title="退款信息" :bordered="false"
              :headStyle="{borderBottom:'0px'}">
        <detail-list :col="6">
          <detail-list-item term="退款时间">{{ orderDetails.orderRefundTime }}</detail-list-item>
          <detail-list-item term="退款金额">{{ orderDetails.orderRefundAmt }}元</detail-list-item>
          <detail-list-item term="退款备注" v-if="orderDetails.travelMadeOrderRefundRemarks">
            {{ orderDetails.travelMadeOrderRefundRemarks }}
          </detail-list-item>
        </detail-list>
      </a-card>
      <template v-if="orderDetails.madeOrderRemarksList">
        <a-card class="install-ly" title="备注信息" :bordered="false" :headStyle="{borderBottom:'0px'}">
          <detail-list :col="1">
            <detail-list-item v-if="orderDetails.madeOrderRemarksList" term="供应商备注">
              <ul class="ul-lh">
                <li v-for="(item,index) in orderDetails.madeOrderRemarksList" :key="index" v-show="item!=''">
                  {{ item }}
                </li>
              </ul>
            </detail-list-item>
          </detail-list>
        </a-card>
      </template>
    </a-card>
    <!-- 备注 -->
    <a-modal title="添加备注"
             :visible="remarkVisible"
             @ok="addMerchantRemark"
             :confirmLoading="confirmLoading"
             @cancel="handleCancel"
    >
      <a-textarea v-model="merchantRemark" placeholder="请输入备注" :maxLength="300" :rows="4"/>
    </a-modal>
    <!-- 主动退款 -->
    <a-modal title="主动退款"
             :visible="InitRefundVisible"
             :footer="null"
             @cancel="handleCancel"
             :width="600"
    >
      <a-form-model :model="ruleForm" ref="ruleForm" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="退款金额" prop="refundAmt">
          <a-input v-model="ruleForm.refundAmt" prefix="￥" suffix="RMB" style="max-width:180px;"/>
          <span>&nbsp;&nbsp;最大可退金额 {{ orderDetails.travelMadeOrderAmt }}元</span>
        </a-form-model-item>
        <a-form-model-item label="退款备注" prop="refundRemarks">
          <a-textarea v-model="ruleForm.refundRemarks" placeholder="请输入备注" :maxLength="300" :rows="4"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存设置</a-button>
          <a-button style="margin-left: 10px;" @click="resetForm">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'

export default {
  name: 'CustomOrderDetails',
  components: {
    Breadcrumb
  },
  computed: {
    // 按当前路由上下文决定面包屑返回目标：新模块回定制游服务，旧模块回订单管理
    backRouteName() {
      return this.$route.name === 'TravelOrderDetail' ? 'TravelMode' : 'CustomOrderList'
    }
  },
  data() {
    var checkMoney = (rule, value, callback) => {
      setTimeout(() => {
        if (Number(value) > Number(this.orderDetails.travelMadeOrderAmt)) {
          callback(new Error('超出最大可退金额'))
        } else {
          callback()
        }
      }, 1000)
    }
    return {
      orderNo: this.$route.query.orderNo,
      submitLoading: false,
      merchantId: this.$store.getters.userInfo.merchantId,
      remarkVisible: false,
      InitRefundVisible: false,
      confirmLoading: false,
      orderDetails: {},
      merchantRemark: '',
      currentFormLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 19 }
      },
      ruleForm: {
        refundAmt: '',//退款金额
        refundRemarks: '',//退款备注
        travelMadeOrderId: ''
      },
      submitFormData: '',
      rules: {
        refundAmt: [
          { required: true, message: '请输入退款金额', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额',
            trigger: 'blur'
          },
          { validator: checkMoney, trigger: 'blur' }
        ],
        refundRemarks: [
          { required: true, message: '请输入退款备注', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'BookList', title: '预约列表' },
      { name: 'CustomOrderList', title: '订单管理' }
    ])
    this.orderNo = this.$route.query.orderNo
    this.getOrderDetails()
  },
  activated() {
    // 页面被 keep-alive 缓存，再次进入时按新的 orderNo 重新加载详情
    this.orderNo = this.$route.query.orderNo
    this.getOrderDetails()
  },
  methods: {
    showRemarkModal() {
      this.remarkVisible = true
    },
    handleCancel(e) {
      this.getLogUtils().logWithTag('Clicked cancel button')
      this.remarkVisible = false
      this.InitRefundVisible = false
    },
    getOrderDetails() {
      this.getHttpServices().getOrderService().get('orderCustomMade/getOrderCustomMadeDetails?travelMadeOrderNo=' + this.orderNo).then(res => {
        this.getLogUtils().logWithTag('==getPayStateList==', res)
        this.orderDetails = res
        this.ruleForm.travelMadeOrderNo = this.orderNo
        this.ruleForm.travelMadeOrderId = res.travelMadeOrderId
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //验证
    checkRemark() {
      if (!this.merchantRemark) {
        this.$message.error('请输入需要备注的信息')
        return false
      }
      return true
    },
    //运营商增加备注信息
    addMerchantRemark() {
      if (this.checkRemark()) {
        this.confirmLoading = true
        this.getHttpServices().getOrderService().post('orderCustomMade/saveCustomMadeOrderRemarks', {
          travelMadeOrderId: this.orderDetails.travelMadeOrderId,
          remarks: this.merchantRemark
        }).then(res => {
          this.$message.success('备注保存成功')
          this.merchantRemark = ''
          this.remarkVisible = false
          this.getOrderDetails()
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.confirmLoading = false)
      }
    },
    showkInitRefundModal() {
      this.InitRefundVisible = true
    },

    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitLoading = true
      this.getHttpServices().getPayApiService().post('refund/refundCustomMadeOrder', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('主动退款成功')
        this.InitRefundVisible = false
        this.getOrderDetails()
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    resetForm() {
      this.ruleForm.refundAmt = ''
      this.ruleForm.refundRemarks = ''
      this.InitRefundVisible = false
    }
  }
}
</script>
<style lang="less">
@import url('../../../CustomPage.less');

.heading {
  font-size: 20px;
  font-weight: 400;
  color: #000;
}

.order-big {
  font-size: 20px;
  font-weight: bold;
  color: #000;
}

.mb20 {
  margin-bottom: 20px;
}

.ul-lh {
  padding-left: 0;
}

ul, li {
  list-style: none;
  margin: 0;
}

.btns-list {
  .mb10 {
    margin-bottom: 10px;
  }

  .ant-btn + .ant-btn {
    margin-left: 10px;
  }
}

input {
  max-width: 500px;
}
</style>